<template>
    <button @click="showFilters = true" class="btn custom-btn mobile-filter-btn" type="button">
        <span class="icon-Filter"></span>
        فیلتر ها
    </button>
</template>

<script>
export default {
    name: "FiltersToggle",
    data() {
        return {

        }
    },
    computed: {
        showFilters: {
            get() {
                return this.$store.state.archive.showFilters;
            },
            set(value) {
                this.$store.commit('archive/setShowFilters', value);
            }
        }
    },
    watch: {
        showFilters(value) {
            if (value) {
                jQuery("body").addClass("noScroll");
            } else {
                jQuery("body").removeClass("noScroll");
            }
        }
    }
}
</script>
